// PlanSelectorChip.tsx
import React from 'react';
import { Chip, Grid, Typography } from '@mui/material';
import PaidIcon from '@mui/icons-material/Paid';
import colors from '../../../styles/colors';

interface Props {
    value: string;
    setValue: (val: string) => void;
}

export const PlanSelectorChip: React.FC<Props> = ({ value, setValue }) => {
    const label =
        value === '1' ? 'Free' : value === '2' ? 'Pré pago' : 'Pós pago';

    const color =
        value === '1' ? 'success' : value === '2' ? 'primary' : 'warning';

    const textColor =
        value === '1' || value === '2' ? colors.IceWhite : colors.DarkerGray;

    const nextValue = value === '1' ? '2' : value === '2' ? '3' : '1';

    return (
        <Grid item 
            style={{ display: 'flex', flexDirection: 'column', paddingLeft: '0'}}
            className="flex flex-col justify-center items-center"
        >

            <Typography variant="body1">Qual tipo de plano?</Typography>
            <Chip
                icon={<PaidIcon />}
                label={label}
                color={color as any}
                sx={{ color: textColor }}
                onClick={() => setValue(nextValue)}
            />
        </Grid>
    );
};